import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { Link  } from 'react-router-dom';
import NewsManager from '../pages/admin/newsManager'
import VideoManager from '../pages/admin/videoManager'
import AdminManager from '../pages/admin/adminManager'

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function CustomizedMenus() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isHidden,setIsHidden] = React.useState(false)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsHidden(false)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const hideMenu = () =>{
    setIsHidden(true)
  }
  return (
    <div style={{ position: 'fixed', right:'5%', top:'10vh', zIndex:500}}>
      <Button
        style={{width:'75px',height:'75px',backgroundColor:'#dd2e60'}}
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
      >
        <WidgetsIcon style={{fontSize:'50px'}}/>
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        sx={{overflowY:'scroll'}}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        autoFocus={false}
      >
        <MenuItem onClick={handleClose} disableRipple >
          <Link to = '/create' style={{textDecoration: 'none'}}>
        <Button style={{color:'rgb(221, 46, 96)'}}>    
        Crear noticia   
        </Button>
        </Link>
        </MenuItem>
        <MenuItem>
          <NewsManager />
        </MenuItem>
        <MenuItem >
          <VideoManager />
        </MenuItem>
        <MenuItem>
          <AdminManager/>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}